import * as React from 'react';
import { find as _find } from 'lodash';
import { Modal } from 'reactstrap';
import { setTimeout } from 'timers';
import { UserModel } from 'franke-trough-dependencies';
import { DateRange } from 'react-date-range';
import { addDays } from 'date-fns';
import './Pricing.scss';


export interface PricingsPeriodModalProps {
  drilledSubmit: (startDate: Date, endDate: Date) => void;
  drilledClose: () => void;
  selectedPricing?: any;
  isDisabled: boolean;
}

export interface PricingsPeriodModalState {
  isOpen: boolean; 
  startDate: Date; 
  endDate: Date; 
  key: string;
}

const toUtcMidnightSameDate = (d: Date) =>
  new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));

export class PricingsPeriodModal extends React.Component<PricingsPeriodModalProps, PricingsPeriodModalState> {
  constructor(props: PricingsPeriodModalProps) {
    super(props);

		const year = new Date().getFullYear();
		const defaultStart = new Date(Date.UTC(year, 0, 1));
		const defaultEnd = new Date(Date.UTC(year, 11, 31));

    this.state = {
      isOpen: false,
      startDate: this.props.selectedPricing ? new Date(this.props.selectedPricing.dateFrom) : defaultStart,
      endDate: this.props.selectedPricing ? new Date(this.props.selectedPricing.dateUntil) : defaultEnd,
      key: 'selection'
    };
  }

  componentDidMount() {
    this.setState({
      isOpen: true,
    });
  }

  componentDidUpdate() {
    if (!this.state.isOpen) {
      this.setState({
        isOpen: true
      });
    }
  }

  public render() {


    return (
      <Modal 
        isOpen={this.state.isOpen} 
        backdrop={true}
        toggle={this.props.drilledClose}
        className="modal-dialog--medium pricings-period-modal"
      >
        <div className="modal-inner d-flex justify-content-center align-items-center vh-100">
          <div>
            <h3 className="modal-heading">Set time period</h3>
            <div className="modal-body">
              <DateRange
                onChange={item => {
                  if (item.range1) {
                    this.setState({
                      startDate: item.range1.startDate || this.state.startDate,
                      endDate: item.range1.endDate || this.state.endDate
                    })
                  }
                }}
                moveRangeOnFirstSelection={false}
                months={2}
                ranges={[
                  {
                    startDate: this.state.startDate, 
                    endDate: this.state.endDate
                  }
                ]}
                rangeColors={['#ce162e']}
                direction="horizontal"
              />
            </div>
            <div className="modal-actions text-center d-flex">
              <button 
                className="btn btn-light btn-bordered w-100"
                disabled={this.props.isDisabled}
                onClick={this.props.drilledClose}
              >
                Cancel
              </button>
              <button 
                className="btn btn-secondary w-100"
                disabled={this.props.isDisabled}
                onClick={this.handleSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  handleSelect = () => {
    console.log('select');
  }

  handleSubmit = () => {
		const startUtc = toUtcMidnightSameDate(this.state.startDate);
		const endUtc   = toUtcMidnightSameDate(this.state.endDate);
		console.log(startUtc, endUtc);
		this.props.drilledSubmit(startUtc, endUtc);
	};
}

// export const PricingsPeriodModal = connect((state: GlobalPrivateState) => ({
// }))(PricingsPeriodModalPartial as any);

export default PricingsPeriodModal;